import { ca } from '@cian/analytics';

/**
 * Клик на кнопку Заметка
 */
export function trackNoteButtonClick() {
  ca('event', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'add_comment',
    label: '',
  });
}
